import { defineComponent as _defineComponent } from 'vue'
import WavePickTote from "@/components/pages/WavePicking/WavePickTote.vue";
import { bus } from "@/bootstrap/bus";
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { PickTask, usePickStore } from "@/stores/tasks/pick-tasks";
import {
  onBeforeRouteLeave,
  useRoute,
  useRouter,
} from "vue-router/composables";
import { Tote } from "@/types/WavePicking";
import { decodeToteScan } from "@/store/wavePicking/helpers";
import ordersApiGateway from "@/api/ordersApiGateway";
import {AbandonmentReasonsEnum} from "@/utilities/AbandonmentReasons";

export type SkuLocationList = { sku: string; location: string };
type AbandonedTote = Tote & {
  scanned: boolean;
  skuLocationList: Array<SkuLocationList>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WavePickAbandon',
  setup(__props, { expose }) {

const pickStore = usePickStore();
const route = useRoute();
const router = useRouter();

const totes = ref<Array<AbandonedTote>>([]);
let sku: number;
let abandonmentReason: AbandonmentReasonsEnum;

onBeforeRouteLeave((to, _from, next) => {
  const exitRoutes = ["wave_pick_tasks", "wave_pick_start"];
  if (to.name && exitRoutes.includes(to.name)) {
    next();
  } else {
    next(false);
  }
});

// computed
const sortedTotes = computed(() => {
  return totes.value.toSorted((a, b) => {
    if (a.scanned === b.scanned) {
      return a.name.localeCompare(b.name);
    }
    return a.scanned > b.scanned ? 1 : -1;
  });
});

const allTotesScanned = computed(() => {
  return !totes.value.some((t) => !t.scanned);
});

// functions
const handleItemScan = (scanResult: string): void => {
  const label = decodeToteScan(scanResult);
  if (!label) return;
  const tote = totes.value.find((tote) => tote.name === label.identifier);
  if (!tote || tote.scanned) return;
  tote.scanned = true;
};

const abandonOrders = (): void => {
  for (const tote of totes.value) {
    ordersApiGateway.abandonOrder({
      abandonment_reason: abandonmentReason,
      order_id: tote.orderHeaderId as unknown as number,
      huboo_sku: sku
    })
    pickStore.actions.removeTasksByTote(tote);
    pickStore.actions.removeTote(tote);
  }
  pickStore.getters.getTasks.length > 0 ? goToTasksPage() : goToStartPage();
};

const goToTasksPage = (): void => {
  router.push({ name: "wave_pick_tasks" });
};

const goToStartPage = (): void => {
  router.push({ name: "wave_pick_start" });
};

onBeforeUnmount(() => {
  bus.$off("barcodeScanned", handleItemScan);
});

onMounted(() => {
  bus.$on("barcodeScanned", handleItemScan);
  sku = +route.params.sku;
  abandonmentReason = route.params.reason as unknown as AbandonmentReasonsEnum;
  for (const tote of pickStore.getters.getTotesBySku(sku, true)) {
    const tasks: PickTask[] = pickStore.getters.getTasksByToteName(
      tote.name,
      true
    );
    const skuLocationList = tasks.map((task) => ({
      sku: task.attributes.sku,
      location: task.attributes.location,
    }));
    totes.value.push({ ...tote, scanned: false, skuLocationList });
  }
});

// used to expose params and methods in tests
expose({
  handleItemScan,
});

return { __sfc: true,pickStore, route, router, totes, sku, abandonmentReason, sortedTotes, allTotesScanned, handleItemScan, abandonOrders, goToTasksPage, goToStartPage, WavePickTote }
}

})